module.exports = __webpack_public_path__ + "0f54543b9968c344dbf2420f800133bf.pdf";